export default __webpack_public_path__ + "static/media/img2.25533199.png";